import { DestroyRef, Injector } from '@angular/core';
/**
 * useful for short-lifetime tracking, e.g. when creating an Injection context that should be destroyed after the function completes.
 * usage:
 * Injector.create({
 *	  providers: [
 *	    {provide:DestroyRef, useValue:destroyRef}
 *	  ],
 *	  parent: injector,
 *	})
 */
export class ManualDestroyRef extends DestroyRef {
  constructor() {
    super(...arguments);
    this._destroyed = false;
    this.cbs = [];
  }
  get destroyed() {
    return this._destroyed;
  }
  onDestroy(cb) {
    this.cbs.push(cb);
    // returns unregisterFn
    return () => {
      this.cbs = this.cbs.filter(entry => entry === cb);
    };
  }
  destroy() {
    this.cbs.forEach(cb => cb());
  }
}
export function injectorWithProviders(parent, providers, name) {
  return Injector.create({
    providers,
    parent,
    name
  });
}